import { useState } from "react";
import { Pagination, Table } from "react-bootstrap";
import styles from "../styles/productMenuList.module.css";
import ProductMenuListItem from "./productMenuListItem";

const ITEMS_PER_PAGE = 20;

export const ProductMenuList = ({
  products = [],
  businessType,
  actions,
}: {
  products?: any[];
  businessType: "brand" | "venue" | undefined;
  actions: Actions;
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate total pages
  const totalPages = Math.ceil(products.length / ITEMS_PER_PAGE);
  // Get current page products
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentProducts = products.slice(indexOfFirstItem, indexOfLastItem);

  // Update page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <div className={styles.wrapper}>
      <Table responsive className="table">
        <thead className={styles.listHeaderWrapper}>
          <tr>
            <th>Product</th>
            {businessType == "venue" && <th>Brand</th>}
            <th>Category</th>
            <th>Strain</th>
            {/* <th>Sub-Category</th> */}
            <th className={styles.actionsColumn}>Actions</th>
          </tr>
        </thead>
        <tbody className={styles.bodyWrapper}>
          {products?.map((product, index) => (
            <ProductMenuListItem key={index} product={product} businessType={businessType} actions={actions} />
          ))}
        </tbody>
      </Table>
      <div className={styles.pagination}>
        <span>
          Showing {indexOfFirstItem + 1} to {indexOfLastItem} of {products.length} results
        </span>
        <Pagination>
          <Pagination.First onClick={() => paginate(1)} disabled={currentPage === 1} />
          <Pagination.Prev onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} />
          {[...Array(totalPages).keys()].map((number) => (
            <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
              {number + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} />
          <Pagination.Last onClick={() => paginate(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
      </div>
    </div>
  );
};
